class HubSpot {

    saveUser = async id => {
        try {
            const res = await fetch('/wp-admin/admin-ajax.php', {
                method: 'POST',
                credentials: 'same-origin',
                headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' }),
                body: new URLSearchParams({
                    action: 'hubspot_save_user_prefs'
                })
            });
            let response = await res.json();
            return response;
        } catch (err) {
            console.log({ id,err });
            return err;
        }
    }

    fetchSubscriptionData = async () => {
        try {
            const res = await fetch('/wp-admin/admin-ajax.php', {
                method: 'POST',
                credentials: 'same-origin',
                headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' }),
                body: new URLSearchParams({
                    action: 'fetch_subscriptions'
                })
            });
            let response = await res.json();
            response = response.reduce((acc, key) => {
                if (!acc[key.id]) {
                    acc[`subscription_${key.id}`] = key.name
                }
                return acc;
            },{})
            return response;
        } catch (err) {
            console.log({ err });
            return err;
        }
    }

}

export default HubSpot;